import { makeFieldValueDbModule } from '../makeFieldValueDbModule';
import { clear as worktypesServiceClear } from './worktypesService';
import { makeClearPublisher } from 'serviceWorker/broadcasts/publishers';
import { fieldValueContracts } from 'shared/domain/fieldValue/fieldValueContracts';
import { EditableFieldValuesEntityName } from 'shared/domain/fieldValue/fields';

export const {
  clear,
  quantity,
  get,
  getOne,
  addBatch,
  updateBatch,
  removeBatch,
} = makeFieldValueDbModule({
  tableName: 'worktypes',
  serviceTableName: 'worktypesService',
  serviceClearFunction: worktypesServiceClear,
  broadcastClearFunction: makeClearPublisher(fieldValueContracts[EditableFieldValuesEntityName.workTypes]),
});
